/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const Star = ({ isActive }: {isActive: boolean}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 12 11"
    fill={isActive ? "#EBB11D" : "black"}
    opacity={isActive ? 1 : 0.5}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 0L7.93969 3.33024L11.7063 4.1459L9.13849 7.01976L9.52671 10.8541L6 9.3L2.47329 10.8541L2.86151 7.01976L0.293661 4.1459L4.06031 3.33024L6 0Z" />
  </svg>
);

export default Star;
